<template>
    <el-dialog :title="titleName" width="50%" class="aaaeditcss" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>


            <el-row>
                <el-col :span="12">
                    <el-form-item label="报表类型" :label-width="formLabelWidth" :required="true" prop="reportCode">
                        <el-select style="width: 100%" v-model="form.reportCode" placeholder="报表类型" clearable >
                            <el-option value="report_zcfzb" label="资产负载表"/>
                            <el-option value="report_lrb" label="利润表"/>
                            <el-option value="report_xjllb" label="现金流量表"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="统计方式" :label-width="formLabelWidth">
                        <el-select style="width: 100%" v-model="form.tjPatternCode" placeholder="统计方式" clearable >
                            <el-option label="库表统计" value="1"/>
                            <el-option label="算数统计" value="2"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="计项名称" :label-width="formLabelWidth" :required="true" prop="itemName">
                        <el-input v-model="form.itemName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="计项代码" :label-width="formLabelWidth">
                        <el-input v-model="form.itemCode" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="统计编号" :label-width="formLabelWidth">
                        <el-input v-model="form.tjNumber" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="左边距离" :label-width="formLabelWidth">
                        <el-input-number v-model="form.leftPx" :min="0" :max="1000" style="width: 100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="行排序号" :label-width="formLabelWidth">
                        <el-input-number v-model="form.rowNum" :min="1" :max="1000" style="width: 100%"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="列排序号" :label-width="formLabelWidth">
                        <el-input-number v-model="form.colNum" :min="1" :max="1000" style="width: 100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                currentPage: 1,
                form: {
                    id: '',
                    reportName: '',
                    reportCode: '',
                    tjPatternName: '',
                    tjPatternCode: '',
                    itemName: '',
                    itemCode: '',
                    tjNumber: '',
                    rowNum: 0,
                    colNum: 0,
                    leftPx: 0
                },
                rules: {
                    id: [{required: true, message: '请输入UUID', trigger: 'blur'}],
                    reportCode: [{required: true, message: '请选择报表类型', trigger: 'blur'}],
                    tjPatternCode: [{required: true, message: '请输选择计方式', trigger: 'blur'}],
                    itemName: [{required: true, message: '请输入统计项名称', trigger: 'blur'}],
                    itemCode: [{required: true, message: '请输入统计项代码', trigger: 'blur'}],
                    tjNumber: [{required: true, message: '请输入统计编号', trigger: 'blur'}]
                },
                formLabelWidth: '86.5px'
            };
        },
        methods: {
            int(id,currentPage) {

                this.currentPage = currentPage;

                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.reportName = '';
                this.form.reportCode = '';
                this.form.tjPatternName = '';
                this.form.tjPatternCode = '';
                this.form.itemName = '';
                this.form.itemCode = '';
                this.form.tjNumber = '';
                this.form.rowNum = 0;
                this.form.colNum = 0;
                this.form.leftPx = 0;

                if (id == 'add') {
                    this.titleName = "报表统计项定义-新增";
                    this.url = "/business/reportItem/save";
                } else {
                    this.titleName = "报表统计项定义-修改";
                    this.url = "/business/reportItem/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/reportItem/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        if(this.form.tjPatternCode == '1'){
                            this.form.tjPatternName = '库表统计';
                        }else if(this.form.tjPatternCode == '2'){
                            this.form.tjPatternName = '算数统计';
                        }else{
                            this.form.tjPatternName = '';
                        }

                        if(this.form.reportCode == 'report_zcfzb'){
                            this.form.reportName = '资产负载表';
                        }else if(this.form.reportCode == 'report_lrb'){
                            this.form.reportName = '利润表';
                        }else if(this.form.reportCode == 'report_xjllb'){
                            this.form.reportName = '现金流量表';
                        }else{
                            this.form.reportName = '';
                        }

                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", this.currentPage);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .aaaeditcss >>> .el-dialog__body {
        padding: 20px 85px 20px 60px;
    }
</style>
